import React from 'react'
import { Typography, Layout, Divider, Table } from 'antd'

const { Title, Paragraph, Text } = Typography

const privacyColumns = [
  { title: 'Finalité', dataIndex: 'finalite', key: 'finalite', render: (text: string) => <Text strong>{text}</Text> },
  { title: 'Base légale', dataIndex: 'base', key: 'base' },
]

const privacyData = [
  { key: '1', finalite: 'Gestion du compte client', base: 'Exécution du contrat (art. 6.1.b RGPD)' },
  { key: '2', finalite: 'Gestion des abonnements et facturation', base: 'Obligation légale' },
  { key: '3', finalite: 'Support technique', base: 'Intérêt légitime' },
  { key: '4', finalite: 'Sécurité et prévention des abus', base: 'Intérêt légitime' },
  { key: '5', finalite: 'Amélioration des services', base: 'Intérêt légitime' },
  { key: '6', finalite: 'Respect des obligations réglementaires', base: 'Obligation légale' },
]

const PrivacyPolicyFR = () => (
  <Layout style={{ padding: '1.5em 0.75em' }}>
    <Typography>
      <Title level={2} style={{ textAlign: 'center', textTransform: 'uppercase' }}>
        POLITIQUE DE CONFIDENTIALITÉ
      </Title>
      <Paragraph style={{ textAlign: 'center' }}>
        <Text strong>Application Web et Mobile « MusicTMM-Universum »</Text>
      </Paragraph>
      <Paragraph style={{ textAlign: 'center' }}>
        <Text type="secondary">Le présent document constitue la Politique de confidentialité de l’application « MusicTMM-Universum ».</Text>
      </Paragraph>
      <Paragraph style={{ textAlign: 'center' }}>
        <Text type="secondary">Date d’entrée en vigueur : 19 juillet 2026</Text>
      </Paragraph>

      <Divider />

      <Paragraph>
        <Text strong>MusicTMM SAS</Text>
        <br />
        99 Avenue Achille Peretti<br />
        92200 Neuilly-sur-Seine<br />
        France<br />
        Email : <Text strong>hello@musictmm.fr</Text>
      </Paragraph>
      <Paragraph>
        MusicTMM SAS agit exclusivement en qualité de <Text strong>Responsable du traitement</Text> pour les données collectées dans le cadre de l’exploitation de la plateforme web et mobile « MusicTMM-Universum ».
      </Paragraph>
      <Paragraph>
        La Société exerce une activité strictement B2B et ne collecte aucune donnée relative aux clients finaux des établissements utilisant la Plateforme.
      </Paragraph>

      <Title level={4}>1. IDENTITÉ DU RESPONSABLE DU TRAITEMENT</Title>
      <Paragraph>
        MusicTMM SAS agit exclusivement en qualité de Responsable du traitement pour les données collectées dans le cadre de l’exploitation de la plateforme web et mobile « MusicTMM-Universum ».
      </Paragraph>
      <Paragraph>
        La Société exerce une activité strictement B2B et ne collecte aucune donnée relative aux clients finaux des établissements utilisant la Plateforme.
      </Paragraph>

      <Title level={4}>2. CATÉGORIES DE DONNÉES TRAITÉES</Title>
      <Title level={5}>2.1 Données d’identification professionnelle</Title>
      <ul>
        <li>adresse email professionnelle</li>
        <li>nom de l’entreprise</li>
        <li>nom du représentant</li>
        <li>adresse commerciale</li>
        <li>numéro de téléphone professionnel</li>
      </ul>
      <Title level={5}>2.2 Données techniques</Title>
      <ul>
        <li>adresse IP</li>
        <li>type et modèle d’appareil</li>
        <li>système d’exploitation</li>
        <li>journaux de connexion</li>
        <li>historique d’utilisation</li>
      </ul>
      <Title level={5}>2.3 Données de localisation</Title>
      <ul>
        <li>localisation approximative (pays, ville)</li>
      </ul>
      <Paragraph>
        Aucune donnée GPS précise n’est collectée sans consentement explicite. Aucune donnée sensible au sens de l’article 9 du RGPD n’est traitée.
      </Paragraph>
      <Paragraph>
        Aucun profilage ni prise de décision automatisée produisant des effets juridiques n’est réalisé.
      </Paragraph>

      <Title level={4}>3. FINALITÉS ET BASES LÉGALES</Title>
      <Paragraph>
        Les données sont traitées aux fins suivantes :
      </Paragraph>
      <Table columns={privacyColumns} dataSource={privacyData} pagination={false} bordered />
      <Paragraph>
        Les intérêts légitimes poursuivis incluent notamment la sécurité de la Plateforme, la prévention des fraudes et l’amélioration continue des services.
      </Paragraph>
      <Paragraph>
        Lorsque le traitement est fondé sur l’intérêt légitime, la personne concernée peut s’y opposer pour des raisons tenant à sa situation particulière.
      </Paragraph>

      <Title level={4}>4. SOUS-TRAITANTS</Title>
      <Paragraph>
        MusicTMM SAS peut faire appel à des sous-traitants techniques ou d’hébergement pour assurer le fonctionnement de la Plateforme. Ces prestataires sont soumis à des obligations contractuelles strictes de confidentialité et de sécurité.
      </Paragraph>
      <Paragraph>
        Les données peuvent être transférées vers des pays hors UE, dans le respect des garanties appropriées prévues par le RGPD.
      </Paragraph>

      <Title level={4}>5. DURÉE DE CONSERVATION</Title>
      <Paragraph>
        Les données sont conservées pendant la durée du contrat, puis archivées conformément aux obligations légales applicables. Les factures sont conservées pendant dix (10) ans ; les journaux techniques pendant un maximum de douze (12) mois.
      </Paragraph>

      <Title level={4}>6. SÉCURITÉ</Title>
      <Paragraph>
        MusicTMM SAS met en œuvre des mesures techniques et organisationnelles adaptées pour protéger les données personnelles, notamment le chiffrement, les contrôles d’accès et les sauvegardes régulières.
      </Paragraph>

      <Title level={4}>7. DROITS DES PERSONNES CONCERNÉES</Title>
      <Paragraph>
        Conformément au RGPD, toute personne concernée peut exercer ses droits d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité. Elle peut également introduire une réclamation auprès de la CNIL.
      </Paragraph>
      <Paragraph>
        Pour exercer ces droits, contacter : <Text strong>hello@musictmm.fr</Text>
      </Paragraph>

      <Title level={4}>8. RÉCLAMATION ET CONTACT</Title>
      <Paragraph>
        Pour toute question relative à cette politique de confidentialité, vous pouvez contacter MusicTMM SAS à l’adresse <Text strong>hello@musictmm.fr</Text>.
      </Paragraph>
    </Typography>
  </Layout>
)

export default PrivacyPolicyFR
